import { FIELDSET_VERTICAL_SPACING } from '@belong/themes';
import styled from 'styled-components';
import { StyledError } from '../Error';

/*
  InputWrapper sets a spacing of 0.8rem between its children.

  However, to have an accessible inline validation,
  the Error component is expected to be mounted
  while its content is dynamically generated

  So we do not apply the margin-top on the div[aria-live]
  but on its children instead.
*/

export const InputWrapper = styled.div`
  border: none;

  > * + *:not(${StyledError}):not([aria-live]) {
    margin-top: ${FIELDSET_VERTICAL_SPACING};
  }

  > ${StyledError} > *,
  > [aria-live] > * {
    margin-top: 0.8rem;
  }
`;

InputWrapper.displayName = 'InputWrapperElement';
